import { getSupabaseClient } from './supabase';

export interface StorySocial {
  localId:string; publicId:string; published:boolean; creatorId:string;
  creatorName:string; creatorAvatar:string|null; followers:number; followed:boolean;
  playCount:number; likeCount:number; liked:boolean;
}
export async function readStorySocial(ids:readonly string[]):Promise<StorySocial[]> {
  const client=getSupabaseClient(); if(!client||!ids.length)return [];
  const result:StorySocial[]=[];
  for(let offset=0;offset<ids.length;offset+=50) {
    const {data,error}=await client.rpc('get_story_social_v1',{p_ids:ids.slice(offset,offset+50)});
    if(error)throw error;
    result.push(...(Array.isArray(data)?data:[]));
  }
  return result;
}
export async function setStoryHeart(publicId:string,enabled:boolean):Promise<{liked:boolean;likeCount:number}> {
  const client=getSupabaseClient();if(!client)throw new Error('ยังไม่เชื่อมต่อบัญชี');
  const {data,error}=await client.rpc('set_bot_reaction_v1',{p_bot_id:publicId,p_kind:'like',p_enabled:enabled});
  if(error)throw error;return data;
}
export async function setCreatorFollow(creatorId:string,enabled:boolean):Promise<void> {
  const client=getSupabaseClient();if(!client)throw new Error('ยังไม่เชื่อมต่อบัญชี');
  const {error}=await client.rpc('set_creator_follow_v2',{p_creator_id:creatorId,p_enabled:enabled});if(error)throw error;
}
export async function recordStoryPlay(publicId:string,sessionId:string):Promise<void> {
  const client=getSupabaseClient();if(!client)throw new Error('ยังไม่เชื่อมต่อบัญชี');
  const {error}=await client.rpc('begin_public_bot_route_v3',{p_bot_id:publicId,p_route_legacy_id:sessionId});if(error)throw error;
}
